










import Vue from 'vue'
import { mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import BaseLayout from '@/layout/BaseLayout.vue'
import CenterFormPanel from '@/components/Common/CenterFormPanel.vue'
import { UserActionTypes } from '@/store/modules/users/actions'

import type { AxiosPromise } from 'axios'
import type { UserCredentials } from '@/models/users'

interface Data {
  inProgress: boolean
  oldPassword: string
  newPassword: string
  newPasswordCheck: string
}

interface Methods {
  [UserActionTypes.ChangePassword]: (payload: UserCredentials) => AxiosPromise<void>
  resetForm: () => void
  handleUpdate: () => Promise<void>
}

interface Computed {
  canUpdate: boolean
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    BaseLayout,
    CenterFormPanel,
  },
  data() {
    return {
      inProgress: false,
      oldPassword: '',
      newPassword: '',
      newPasswordCheck: '',
    }
  },
  computed: {
    canUpdate(): boolean {
      return (
        !this.inProgress &&
        this.oldPassword.length > 0 &&
        this.newPassword.length > 0 &&
        this.newPassword === this.newPasswordCheck
      )
    },
  },
  methods: {
    ...mapActions([UserActionTypes.ChangePassword]),
    resetForm() {
        this.oldPassword = ''
        this.newPassword = ''
        this.newPasswordCheck = ''
    },
    async handleUpdate() {
      if (!this.canUpdate) {
        return
      }

      try {
        this.inProgress = true

        const payload: UserCredentials = {
          old: this.oldPassword,
          new: this.newPassword,
        }

        await this[UserActionTypes.ChangePassword](payload)

        this.$store.dispatch(ADD_TOAST_MESSAGE, {
          text: this.$tc('auth.passwordComplete'),
          type: 'info',
        })

        this.resetForm()
        this.inProgress = false
      } catch (e) {
        this.inProgress = false
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { status, code } = e as any || {}

        if (status !== 400) {
          this.$store.dispatch(ADD_TOAST_MESSAGE, {
            text: this.$tc(`serverErrors.${code || 'unknownError'}`),
            type: 'danger',
          })
        }
      }
    },
  },
  metaInfo() {
    return { title: this.$tc('auth.changingPassword') }
  },
})
